<template>
  <v-btn
    block
    dark
    :color="btn.color"
    @click="login"
  >
    {{ myText || btn.text }}
  </v-btn>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'LoginWithSocial',

  props: {
    provider: {
      type: String,
      default: 'facebook'
    },
    myText: {
      type: String,
      default: ''
    },
    myCallback: {
      type: String,
      default: ''
    },
    fromFacebook: {
      type: Boolean,
      default: false
    },
    fromRegister: {
      type: Boolean,
      default: false
    },
    url: ''
  },
  computed: {
    ...mapGetters('config', [
      'gid', 'theme'
    ]),
    ...mapGetters('auth', [
      'user'
    ]),
    ...mapGetters('member', [
      'isMember'
    ]),
    btn () {
      switch (this.provider) {
        case 'google':
          return {
            color: '#CA4F40',
            icon: 'fa-google-plus',
            text: this.fromRegister ? this.$t('sign_up_google') : this.$t('login_google')
          }
        case 'facebook':
        default:
          return {
            color: '#4A68AD',
            icon: 'fa-angellist',
            text: this.fromRegister ? this.$t('sign_up_facebook') : this.$t('login_facebook')
          }
      }
    }
  },
  methods: {
    login () {
      openWindow(this.url, this.$t('login'))
    }
  },
  async created () {
    if (this.url === 'Already authenticated.') {
      if (this.isMember) {
        if (this.myCallback) {
          const result1 = await axios.get('/api/user')
          const user = result1.data
          const params = {
            callback: this.myCallback,
            fb: user.social_id
          }
          await axios.post('/api/fb/callback', params)
        }
        this.$router.push({ name: 'home' })
      } else {
        if (this.myCallback) {
          this.$router.push({ name: 'register2', query: { callback: this.myCallback }})
        } else {
          this.$router.push({ name: 'register2' })
        }
      }
    }
  }
}

/**
 * @param  {Object} options
 * @return {Window}
 */
function openWindow (url, title, options = {}) {
  if (typeof url === 'object') {
    options = url
    url = ''
  }

  options = { url, title, width: 600, height: 720, ...options }

  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screen.left
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screen.top
  const width = window.innerWidth || document.documentElement.clientWidth || window.screen.width
  const height = window.innerHeight || document.documentElement.clientHeight || window.screen.height

  options.left = ((width / 2) - (options.width / 2)) + dualScreenLeft
  options.top = ((height / 2) - (options.height / 2)) + dualScreenTop

  const optionsStr = Object.keys(options).reduce((acc, key) => {
    acc.push(`${key}=${options[key]}`)
    return acc
  }, []).join(',')

  const newWindow = window.open(url, title, optionsStr)

  if (window.focus) {
    newWindow.focus()
  }

  return newWindow
}
</script>



// WEBPACK FOOTER //
// src/components/LoginWithSocial.vue